/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Directory_Card_Activity_AriaInputs */

const en_directory_card_activity_aria = /** @type {(inputs: Directory_Card_Activity_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Product activity for ${i?.name}`)
};

const zh_directory_card_activity_aria = /** @type {(inputs: Directory_Card_Activity_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} 的产品动态`)
};

/**
* | output |
* | --- |
* | "Product activity for {name}" |
*
* @param {Directory_Card_Activity_AriaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_card_activity_aria = /** @type {((inputs: Directory_Card_Activity_AriaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Card_Activity_AriaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_card_activity_aria(inputs)
	return zh_directory_card_activity_aria(inputs)
});
export { directory_card_activity_aria as "directory.card.activity_aria" }